var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLegendScore2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1264,
    height: 48,
    viewBox: "0 0 1264 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 24H1240",
    stroke: "#71EB65",
    strokeWidth: 48,
    strokeLinecap: "square",
    strokeDasharray: "200 150"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendScore2);
export default __webpack_public_path__ + "static/media/legend-score2.3a8b0645fc018d38b5b98270cb743534.svg";
export { ForwardRef as ReactComponent };